var _circle, _circle2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContextMenuDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.33333,
    cy: 8.00008,
    r: 1.33333,
    stroke: "#1C274C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99984,
    cy: 8.00008,
    r: 1.33333,
    stroke: "#1C274C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.6668,
    cy: 8.00008,
    rx: 1.33333,
    ry: 1.33333,
    stroke: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextMenuDots);
export default __webpack_public_path__ + "static/media/ContextMenuDots.068432d2f2d6a0368ec74888ff14d33e.svg";
export { ForwardRef as ReactComponent };